import { PropsWithChildren } from 'react';

import { last } from 'lodash';

import {
  AnyRouteRefParams,
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  useRouteRef,
} from '@backstage/core-plugin-api';

export type ResourcePathArgs<
  Params extends { id: string } = AnyRouteRefParams & { id: string },
> = PropsWithChildren<{
  routeRef?: RouteRef<Params> | SubRouteRef<Params> | ExternalRouteRef<Params>;
  name: string;
  params?: Omit<Params, 'id'>;
  transform?: (path: string) => string;
}>;

export const useResourcePath = ({
  routeRef,
  name,
  params,
  transform = s => s,
}: ResourcePathArgs) => {
  const resourceRoute = useRouteRef(routeRef as ExternalRouteRef);

  const id = last(name.split('/'));
  if (!resourceRoute) {
    // eslint-disable-next-line no-console
    console.warn(`Could not generate path to ${name}`);
    return null;
  }
  return transform(resourceRoute({ ...params, id }));
};
